import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';
import TextField from '../../normal/GeneralTextField';

const propTypes = {
  classes: PropTypes.shape({
    textLabel: PropTypes.string,
    textValue: PropTypes.string,
    textWrapper: PropTypes.string,
  }).isRequired,
  isEditing: PropTypes.bool.isRequired,
  initialValue: PropTypes.string,
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }).isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  textValue: PropTypes.string,
};

const defaultProps = {
  initialValue: '',
  textValue: '',
};

const ViewableTextField = props => {
  const {
    classes,
    isEditing,
    initialValue,
    textValue,
    label,
    input: { value, onChange, onBlur, onFocus },
    meta: { error, touched, invalid },
    id,
    ...otherProps
  } = props;

  const renderField = () => {
    if (isEditing) {
      return (
        <TextField
          {...otherProps}
          label={label}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          errMsg={error}
          invalid={invalid}
          touched={touched}
          id={id}
        />
      );
    }

    return (
      <div className={classes.textWrapper}>
        <div className={classes.textLabel}>{label}</div>
        <div className={classes.textValue} id={`${id}-text-value`}>
          {textValue || value}
        </div>
      </div>
    );
  };

  return <div>{renderField()}</div>;
};

ViewableTextField.propTypes = propTypes;
ViewableTextField.defaultProps = defaultProps;

export default withStyles(styles)(ViewableTextField);
